export const TRUCK_TYPES = {
	LANE: 'LANE',
	TRUCK: 'TRUCK',
};
